import { z } from '@harvestiq/zod';
import { dbEvergreenSigningAgentSchema } from './db-evergreen-signing-agent';

export const deleteEvergreenSigningAgentRequestParamsSchema = z.object({
  id: z.string().uuid(),
});

export type DeleteEvergreenSigningAgentRequestParams = z.infer<
  typeof deleteEvergreenSigningAgentRequestParamsSchema
>;

export const deleteEvergreenSigningAgentSuccessResponseSchema = z.object({
  data: dbEvergreenSigningAgentSchema,
});

export type DeleteEvergreenSigningAgentSuccessResponse = z.infer<
  typeof deleteEvergreenSigningAgentSuccessResponseSchema
>;

export const deleteEvergreenSigningAgentErrorResponseSchema = z.object({
  errors: z.array(
    z.object({
      message: z.string(),
      key: z.string().optional(),
      source: z.string().optional(),
    })
  ),
});

export type DeleteEvergreenSigningAgentErrorResponse = z.infer<
  typeof deleteEvergreenSigningAgentErrorResponseSchema
>;

export const deleteEvergreenSigningAgentResponseSchema =
  deleteEvergreenSigningAgentSuccessResponseSchema.or(
    deleteEvergreenSigningAgentErrorResponseSchema
  );

export type DeleteEvergreenSigningAgentResponse = z.infer<
  typeof deleteEvergreenSigningAgentResponseSchema
>;
